/* global axios */
import ApiClient from './ApiClient';

class DashboardHomeAPI extends ApiClient {
  constructor() {
    super('dashboard', { accountScoped: true });
  }

  getHomeStats() {
    return axios.get(`${this.baseUrl()}/dashboard/home_stats`);
  }

  // scope: 'personal' | 'shared'. from/to: ISO strings (opcional; sem eles = janela padrão).
  getAgenda(scope = 'personal', from = null, to = null) {
    const params = { scope };
    if (from) params.from = from;
    if (to) params.to = to;
    return axios.get(`${this.baseUrl()}/dashboard/agenda`, { params });
  }
}

export default new DashboardHomeAPI();
